import type Leaflet from 'leaflet';
import React, { FunctionComponent, useCallback, useRef, useContext } from 'react';
// import { renderToStaticMarkup } from 'react-dom/server';
import type ReactLeaflet from 'react-leaflet';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import type { Marker } from 'react-leaflet';
import Box from '../../../elements/Box';
// import Icon from '../../../elements/Icon';
import { MarkerData } from '../classes/MarkerData';

export interface BeginRouteMarkerProps {
  marker: MarkerData;
  iconSettings?: $TSFixMe;
  markerIconSettings?: $TSFixMe;
  iconSettingsStyles?: $TSFixMe;
  labelSettings?: $TSFixMe;
  popupSettings: $TSFixMe;
  showLabel?: boolean;
  showAirportIataCode?: boolean;
}

export type BeginRouteMarkerPropsType = BeginRouteMarkerProps;

const BeginRouteMarker: FunctionComponent<BeginRouteMarkerPropsType> = (
  props: BeginRouteMarkerPropsType
) => {
  const {
    marker,
    iconSettings = {},
    // markerIconSettings = {},
    iconSettingsStyles = {},
    labelSettings = {},
    showLabel = true,
    popupSettings = {},
    showAirportIataCode = false,
    ...markerSettings
  } = props;

  const { direction, theme } = useContext(Context);
  const markerRef = useRef<Marker | null>(null);

  const handleMarkerRef = useCallback((ref: Marker) => {
    if (ref) {
      ref.leafletElement.openPopup();
      markerRef.current = ref;
    }
  }, []);

  const { Marker, Popup } = require('react-leaflet') as typeof ReactLeaflet;
  const leaflet = require('leaflet') as typeof Leaflet;

  /**
   * TODO: Investigate why within the renderToStaticMarkup function the
   * context of the iconProvider is not evaluated, momentarily a static icon is used
   */
  // const renderIcon = <Icon size={20} viewBox="0 0 24 24" {...markerIconSettings} />;

  const [iconClassName] = useStyles(iconSettingsStyles, { direction, theme });
  const icon = leaflet.divIcon({
    className: 'custom-div-icon',
    html: `<div class="marker-pin mp-selected ${iconClassName}"><svg class="fr-icon fr-text-white " style="fill:currentColor" width="20" height="20" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path></svg></div>`,
    iconSize: [30, 30],
    ...iconSettings
  });

  return (
    <>
      <Marker
        position={marker.location}
        icon={icon}
        ref={handleMarkerRef}
        interactive={false}
        keyboard={false}
        {...markerSettings}
      >
        {showLabel && (
          <Popup
            direction="top"
            autoClose={false}
            closeOnClick={false} // TODO: This was null. Why?
            closeOnEscapeKey={false}
            closeButton={false}
            autoPan={false}
            className="origin-route-popup"
            {...popupSettings}
          >
            <Box {...labelSettings}>{`${marker.name} ${
              showAirportIataCode ? `(${marker.value})` : ''
            }`}</Box>
          </Popup>
        )}
      </Marker>
    </>
  );
};

export default BeginRouteMarker;
